module.exports = __webpack_public_path__ + "assets/webgl/wp_all_the_same_color.7e332d4c.jpg";